import { api } from '@/api/axiosInstance';
import { ApiResponseType } from '@/api/type/commonTypes';
import {
  GetLicenseKeyListResponse,
  GetNoneKeywordListRequest,
} from '../type/types';

// 라이선스 키 목록 조회
export const getLicenseKeyList = async (params: GetNoneKeywordListRequest) => {
  const query = Object.fromEntries(
    Object.entries(params).filter(
      ([_, v]) => v !== undefined && v !== null && v !== ''
    )
  );
  const res = await api.get<ApiResponseType<GetLicenseKeyListResponse>>(
    `/api/web/admins/license-keys`,
    { params: query }
  );
  return res.data;
};
